var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Navigation/arrow/right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Pre-submission]-Configure_basic-info-error-loading",
    transform: "translate(-22.000000, -77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-page-header",
    transform: "translate(0.000000, 56.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 15.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/arrow/right",
    transform: "translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71369295,10.2666667 L11.7676349,7.06666667 C12.033195,6.8 12.033195,6.4 11.7676349,6.13333333 L10.8381743,5.2 C10.5726141,4.93333333 10.1742739,4.93333333 9.90871369,5.2 L4.19917012,11.2 C3.93360996,11.4666667 3.93360996,11.8666667 4.19917012,12.1333333 L9.90871369,18.1333333 C10.1742739,18.4 10.5726141,18.4 10.8381743,18.1333333 L11.7676349,17.2 C12.033195,16.9333333 12.033195,16.5333333 11.7676349,16.2666667 L8.71369295,13.0666667 L19.3360996,13.0666667 C19.7344398,13.0666667 20,12.8 20,12.4 L20,11.0666667 C20,10.5333333 19.7344398,10.2666667 19.3360996,10.2666667 L8.71369295,10.2666667 Z",
    id: "Left_4",
    transform: "translate(12.000000, 11.666667) scale(-1, 1) translate(-12.000000, -11.666667) "
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Arrow-Left.f5314a5f4283c5f171cb2e4fed1a14bf.svg";